import React, { useContext, useState } from 'react'
import { EasybakeContext } from '../EasybakeProvider'
import { Card, CardPreview, CardBody } from '@react/react-spectrum/Card'
import Checkbox from '@react/react-spectrum/Checkbox'
import { __ } from 'i18n-for-browser'
import '../../config/i18n'
import analytics from '../../config/analytics'

export default function SelectSizes ({ group, action, referrer }) {
    const { adSizes, dispatch } = useContext(EasybakeContext)
    const [selectedAll, setSelectedAll] = useState(false)

    function selectionChange (e, id) {
        const checked = !!e
        const newAdSizes = adSizes.map(size => {
            if (size.id === id) {
                size.checked = checked
                analytics.sendEventName('apply', `${referrer}:selectsize:${size.label}:${checked}`)
            }
            return size
        })
        dispatch({ type: 'set-sizes', payload: { group, action, checked, adSizes: newAdSizes } })
        setSelectedAll(adSizes.filter(size => size.checked === true).length === adSizes.length)
    }

    function selectAll (checked) {
        const newAdSizes = adSizes.map(size => {
            if (size.name !== 'Original') {
                size.checked = checked
                analytics.sendEventName('apply', `${referrer}:selectAll:${checked}`)
            }
            return size
        })
        dispatch({ type: 'set-sizes', payload: { group, action, checked, adSizes: newAdSizes } })
        setSelectedAll(adSizes.filter(size => size.checked === true).length === adSizes.length)
    }

    function getSizeThumbnails () {
        const adSizesToShow = adSizes.filter(size => size.name !== 'Original')
        const thumbs = adSizesToShow.map(size => {
            return <div className="adobe-easybake-reflow-size-card" key={size.id} onClick={ e => selectionChange(!size.checked, size.id)}>
                <Card variant="quiet"
                    size="S"
                    onSelectionChange={ e => selectionChange(e, size.id) }
                    selected={size.checked}>
                    <CardPreview>
                        <div className="adobe-easybake-reflow-size-canvas-container">
                            <canvas className="adobe-easybake-reflow-size-canvas" id={size.id} width={size.width} height={size.height} />
                        </div>
                    </CardPreview>
                    <CardBody title={size.name} subtitle={`${size.label}`} />
                </Card>
            </div>
        })
        return thumbs
    }

    return (
        <div className="adobe-easybake-reflow-size-cards">
            <div className="adobe-easybake-reflow-size-cards-selectall">
                <Checkbox checked={selectedAll} onChange={ e => selectAll(e) }>{__('bannerreflow_nav_selectall')}</Checkbox>
            </div>
            { getSizeThumbnails() }
        </div>
    )
}
